import { ManipulativeType } from 'app/question/constants/manipulative-type.enum';
import { QuestionAnswerType } from 'app/question/constants/question-answer-type';

export function isSimpleAnswer(answerType: QuestionAnswerType): boolean {
  return !answerType
    || answerType === QuestionAnswerType.MultipleChoiceAnswers
    || answerType === QuestionAnswerType.ArrangeInOrder
    || answerType === QuestionAnswerType.MultiSelectAnswers;
}

export function isFreeForm(answerType: QuestionAnswerType, manipulativeType?: ManipulativeType): boolean {
  return answerType === QuestionAnswerType.OpenAnswer
    && manipulativeType !== ManipulativeType.DragAndDrop
    && manipulativeType !== ManipulativeType.Clickable
    && manipulativeType !== ManipulativeType.Windows
    && manipulativeType !== ManipulativeType.ImageSwap
    && manipulativeType !== ManipulativeType.DotConnect
    && manipulativeType !== ManipulativeType.Scorable
    && manipulativeType !== ManipulativeType.Graph;
}

export function isManipulative(answerType: QuestionAnswerType, manipulativeType?: ManipulativeType): boolean {
  return answerType === QuestionAnswerType.OpenAnswer && (
    manipulativeType === ManipulativeType.DragAndDrop
    || manipulativeType === ManipulativeType.Clickable
    || manipulativeType === ManipulativeType.Windows
    || manipulativeType === ManipulativeType.DotConnect
    || manipulativeType === ManipulativeType.Scorable
    || manipulativeType === ManipulativeType.Graph
    || manipulativeType === ManipulativeType.BaseManip);
}

export function isGeneralManipulative(answerType: QuestionAnswerType, manipulativeType: ManipulativeType): boolean {
  return isManipulative(answerType, manipulativeType);
}

export function isImageSwap(answerType: QuestionAnswerType, manipulativeType: ManipulativeType): boolean {
  return answerType === QuestionAnswerType.OpenAnswer && manipulativeType === ManipulativeType.ImageSwap;
}

export function replaceFISChoice(questionTextRendered?: string): string {
  if (!questionTextRendered) {
    return '';
  }

  const multiplyRegex = /(<kh-manip-(imageswap))/gi;
  if (multiplyRegex.test(questionTextRendered)) {
    questionTextRendered = questionTextRendered.replace(/value="[^"]*"/, 'value="Question.AnswerText"');
  }

  return questionTextRendered;
}
